import { makeStyles } from "@material-ui/core/styles"
import React from "react"
import PropTypes from "prop-types"
import { Box } from "@material-ui/core"
import { formElements } from "../../i18n/lstrings"
import useSmartFormat from "../../i18n/useSmartFormat"
import FieldTextarea from "./FieldTextarea"

const useFieldStyle = makeStyles(() => ({
  field: {
    maxWidth: "inherit",
    width: "100%"
  }
}))

export default function FieldsAddress(props) {
  const { element, onBlur, fields } = props
  const { id } = element
  const classes = useFieldStyle()
  const format = useSmartFormat()

  /**
   * Inject the onBlur to a FieldTextarea's props because redux-forms won't do it
   * @param textareaProps
   * @returns {*}
   */
  function injectBlur(textareaProps) {
    // eslint-disable-next-line no-param-reassign
    textareaProps.input.onBlur = onBlur
    return textareaProps
  }

  return (
    <>
      <Box display="flex">
        <FieldTextarea
          {...injectBlur(fields[id].address)}
          id={`${id}.address`}
          type="text"
          label={format(formElements.address)}
          className={classes.field}
        />
      </Box>
      <Box display="flex" justifyContent="space-between">
        <FieldTextarea
          {...injectBlur(fields[id].city)}
          id={`${id}.city`}
          type="text"
          label={format(formElements.city)}
          className={classes.field}
        />
        <FieldTextarea
          {...injectBlur(fields[id].postalCode)}
          id={`${id}.postalCode`}
          type="text"
          label={format(formElements.postalCode)}
          className={classes.field}
        />
        <FieldTextarea
          {...injectBlur(fields[id].country)}
          id={`${id}.country`}
          type="text"
          label={format(formElements.country)}
          className={classes.field}
        />
      </Box>
    </>
  )
}

FieldsAddress.propTypes = {
  element: PropTypes.object.isRequired,
  onBlur: PropTypes.func.isRequired,
  fields: PropTypes.array.isRequired
}
